class SetPostPaidReq{
    constructor(){
        this.packageId = null;
        this.postPaidPercentage = null;
    }
}

export default SetPostPaidReq;